import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UserPlus } from 'lucide-react';
import { getBrandMarketingChannelOptions } from '../../shared/utils/brandRegions';
import CrmCoreListPage from './components/CrmCoreListPage';

const LeadsPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.crm.pages.leadsPage.${key}`, opts);

  const statusOptions = useMemo(() => [
    { value: 'new', label: p('status_new') },
    { value: 'contacted', label: p('status_contacted') },
    { value: 'qualified', label: p('status_qualified') },
    { value: 'converted', label: p('status_converted') },
    { value: 'lost', label: p('status_lost') },
  ], [t]);

  const sourceOptions = useMemo(() => getBrandMarketingChannelOptions(), []);

  return (
    <CrmCoreListPage
      pageKey="leadsPage"
      apiPath="/crm/leads"
      icon={UserPlus}
      showValueTier
      entityRef={{ field: 'lead_ref', prefixKey: 'lead', fallback: 'LED' }}
      statusOptions={statusOptions}
      sourceOptions={sourceOptions}
      mapRecord={(r) => ({
        ...r,
        value: r.estimated_value,
        status: r.status,
      })}
      buildPayload={(form) => ({
        name: form.name,
        company: form.company,
        email: form.email,
        phone: form.phone,
        source: form.source || 'whatsapp',
        status: form.status || 'new',
        estimated_value: parseFloat(form.estimated_value) || 0,
        notes: form.notes || '',
      })}
      fields={[
        { name: 'name', labelKey: 'field_name', required: true, placeholderKey: 'placeholder_name' },
        { name: 'company', labelKey: 'field_company', placeholderKey: 'placeholder_company' },
        { name: 'email', labelKey: 'field_email', inputType: 'email', placeholderKey: 'placeholder_email' },
        { name: 'phone', labelKey: 'field_phone', inputType: 'tel' },
        { name: 'source', labelKey: 'field_source', type: 'select', options: sourceOptions, defaultValue: 'whatsapp' },
        { name: 'status', labelKey: 'field_status', type: 'select', options: statusOptions, defaultValue: 'new' },
        { name: 'estimated_value', labelKey: 'field_estimated_value', inputType: 'number', placeholderKey: 'placeholder_value' },
        { name: 'notes', labelKey: 'field_notes', type: 'textarea', fullWidth: true },
      ]}
      columns={[
        { key: 'lead_ref', labelKey: 'col_ref' },
        { key: 'name', labelKey: 'col_name' },
        { key: 'company', labelKey: 'col_company' },
        { key: 'phone', labelKey: 'col_phone', type: 'phone' },
        { key: 'estimated_value', labelKey: 'col_value', type: 'money' },
        { key: 'tier', labelKey: 'col_tier', type: 'tier', derive: (r) => r.estimated_value },
        { key: 'status', labelKey: 'col_status', type: 'status' },
        { key: 'created_at', labelKey: 'col_created', type: 'date' },
      ]}
    />
  );
};

export default LeadsPage;
